import {currentUser} from './FirestoreService';

type QueryResult = Array<Record<string, unknown>>;

/**
 * Calls a whitelisted query against the Orennia Snowflake share via the
 * snowflakeEndpoint Cloud Function. The set of supported `queryName` values is
 * defined server-side; passing an unknown name returns a 404.
 */
const callSnowflakeQuery = async (
  queryName: string,
  params: unknown[] | null = null,
): Promise<QueryResult> => {
  const requestBody: {queryName: string; params?: unknown[]} = {queryName};
  if (params) {
    requestBody.params = params;
  }

  let url = 'https://us-central1-beyondmaps-dev.cloudfunctions.net/snowflakeEndpoint';
  if (process.env.VUE_APP_GCP_ENV === 'production') {
    url = 'https://us-central1-northpoint-production.cloudfunctions.net/snowflakeEndpoint';
  }

  const token = await currentUser()?.getIdToken();
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    },
    body: JSON.stringify(requestBody),
  });

  const json = await response.json();
  if (response.status !== 200) {
    throw new Error(json.error);
  }

  return json.result;
};

export {
  callSnowflakeQuery,
};
